import React from "react";
import { Link } from "react-router-dom";
import { Heart, Phone, Mail, MapPin, Instagram, Facebook, Youtube } from "lucide-react";
import { useCategories } from "../context/CategoriesContext";

const Footer = () => {
  const { categories } = useCategories();
  const mekanCats = categories.filter((c) => c.group === "mekan").slice(0, 6);
  const firmaCats = categories.filter((c) => c.group === "firma").slice(0, 6);
  return (
    <footer className="bg-[#2A2224] text-[#E9DEDF] pt-16 pb-8 mt-10">
      <div className="max-w-7xl mx-auto px-5">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-full flex items-center justify-center bg-gradient-to-br from-[#C15B6B] to-[#9E2A3B]">
                <Heart className="w-5 h-5 text-white" fill="white" />
              </div>
              <div>
                <span className="font-display text-xl font-bold text-white block leading-none">DüğünSenin</span>
                <span className="text-[10px] tracking-[0.22em] text-[#C6A15B]">.COM</span>
              </div>
            </div>
            <p className="text-sm text-[#B7A8AA] leading-relaxed">
              Türkiye'nin en büyük düğün hazırlıkları rehberi. Hayalinizdeki düğün için aradığınız her şey tek adreste.
            </p>
            <div className="flex gap-3 mt-5">
              {[Instagram, Facebook, Youtube].map((Icon, i) => (
                <a key={i} href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#9E2A3B] flex items-center justify-center transition-colors">
                  <Icon className="w-4 h-4 text-white" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display text-lg text-white mb-4">Düğün Mekanları</h4>
            <ul className="space-y-2.5">
              {mekanCats.map((c) => (
                <li key={c.slug}>
                  <Link to={`/kategori/${c.slug}`} className="text-sm text-[#B7A8AA] hover:text-[#E3CE9E] transition-colors">{c.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg text-white mb-4">Düğün Firmaları</h4>
            <ul className="space-y-2.5">
              {firmaCats.map((c) => (
                <li key={c.slug}>
                  <Link to={`/kategori/${c.slug}`} className="text-sm text-[#B7A8AA] hover:text-[#E3CE9E] transition-colors">{c.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg text-white mb-4">İletişim</h4>
            <ul className="space-y-3.5">
              <li className="flex items-start gap-3 text-sm text-[#B7A8AA]">
                <MapPin className="w-4 h-4 mt-0.5 text-[#C6A15B]" /> Atatürk Bulvarı, Samsun, Türkiye
              </li>
              <li className="flex items-center gap-3 text-sm text-[#B7A8AA]">
                <Phone className="w-4 h-4 text-[#C6A15B]" />
                <a href="tel:+905323222130" data-testid="footer-phone" className="hover:text-white transition-colors">+90 532 322 21 30</a>
              </li>
              <li className="flex items-center gap-3 text-sm text-[#B7A8AA]">
                <Mail className="w-4 h-4 text-[#C6A15B]" /> info@dugunsenin.com
              </li>
            </ul>
            <Link to="/firma-kayit" className="inline-flex items-center gap-2 mt-5 px-5 py-2.5 rounded-full bg-white/10 hover:bg-[#9E2A3B] text-white text-sm font-medium transition-colors">
              İşletmeni Ekle
            </Link>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#8f8082]">
            <Link to="/patron" aria-label="Yönetim" className="cursor-pointer hover:text-[#E3CE9E] transition-colors">©</Link>
            {" "}{new Date().getFullYear()} DüğünSenin.com — Tüm hakları saklıdır.
          </p>
          <p className="text-xs text-[#8f8082]">Sevgiyle tasarlandı ❤</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
